export default "__VITE_ASSET__DJfcvAzp__"